import { useMutation, useQueryClient } from '@tanstack/react-query';

import { crmScreenerApiClient } from '@/adapters/schemaClients';
import { FIND_ALL_OUTBOUND_REFERRALS_QUERY_KEY } from '@/pages/CRM/ReferralOutbound/hooks/useOutboundReferralsQuery';
import type { UpdateReferralStatusRequest } from '@/types/crm-screener-api';

import { REFERRAL_DETAIL_QUERY_KEY } from './useReferralDetailQuery';

export function useUpdateReferralStatusMutation(referralId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: UpdateReferralStatusRequest) =>
      crmScreenerApiClient.updateReferralStatus({
        referralId,
        updateReferralStatusRequest: params
      }),
    onSuccess: () => {
      queryClient.invalidateQueries([REFERRAL_DETAIL_QUERY_KEY, referralId]);
      queryClient.invalidateQueries([FIND_ALL_OUTBOUND_REFERRALS_QUERY_KEY]);
    }
  });
}
